import React, { useCallback, useEffect, useId, useRef, useState } from 'react';
import { Box, Grid, IconButton } from '@cko/primitives';
import { IconActionMore } from '@cko/icons';
import styled from 'styled-components';
import { usePopper } from 'react-popper';
import { ThreeDotMenuItemNext } from './ThreeDotMenuItemNext';
import { Portal } from '../Portal';
const Container = styled(Box) `
  position: relative;
`;
export const FloatingBox = styled(Box) `
  position: absolute;
  min-width: 180px;
  z-index: 99;
  border-radius: var(--border-r-seed);
`;
const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};
export const ThreeDotMenuNext = ({ children, id, items, testId = 'three-dot-menu', ...rest }) => {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const closeMenu = useCallback(() => {
        setIsVisible(false);
    }, []);
    useOnClickOutside(ref, closeMenu);
    const [referenceRef, setReferenceRef] = useState(null);
    const [popperRef, setPopperRef] = useState(null);
    const { styles, attributes } = usePopper(referenceRef, popperRef, {
        placement: 'bottom-end',
        modifiers: [
            {
                name: 'flip',
                enabled: false,
            },
            {
                name: 'offset',
                options: {
                    offset: [0, 4],
                },
            },
        ],
    });
    const randomId = useId();
    const referenceId = id || randomId;
    const menuId = `${referenceId || randomId}-menu`;
    const toggleMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsVisible(!isVisible);
    };
    const childOnClick = (e, onClick) => {
        setIsVisible(false);
        onClick(e);
    };
    return (React.createElement(Container, null,
        React.createElement(IconButton, { "aria-controls": menuId, "aria-haspopup": "true", "data-testid": testId, icon: IconActionMore, id: referenceId, onClick: toggleMenu, ref: setReferenceRef, ...rest }),
        isVisible && (React.createElement(Portal, null,
            React.createElement(FloatingBox, { "aria-labelledby": referenceId, id: menuId, ref: setPopperRef, role: "menu", style: styles.popper, ...attributes.popper },
                React.createElement(Grid, { ref: ref, gridGap: "var(--layout-seed)", backgroundColor: "var(--base-bg-primary)", boxShadow: "var(--control-e-sheep)" },
                    children,
                    items?.map((item) => (React.createElement(ThreeDotMenuItemNext, { ...item, key: item.text, onClick: (e) => childOnClick(e, item.onClick) })))))))));
};
